<template>
    <template v-if="!isProductPage">
    <Header></Header>
    <main>    
        <FirstBlock v-if="fields" :fields="fields['First section']">
            <template #search>
                <Search v-model="filters.search" @search="getSearchBlogs" :data_name="'title'" :sort="seacrhData"></Search>
            </template>
            <template #sortby>
                <SortBy class="sort-by" v-model="filters.sortBy" :sort="sortOptions" style="position: absolute; right: 64px; bottom: 48px;"></SortBy>
            </template>

        </FirstBlock>
        <section class="blog__list__container">
            <BlogList :array="posts"></BlogList>
        </section>
        <PosotionImgContent
        :content="{
            imageSrc: require('@/assets/img/image.png'),
            title: 'Learn about our Services',
            description: 'Schneider Industries offers a comprehensive suite of services tailored for the dairy, liquid food, and beverage industries. ',
            buttonText: 'Show All Services',
            imagePosition: 'right'
        }"
        ></PosotionImgContent>
        <FaqBlock style="padding-top: 140px; padding-bottom: 140px;"></FaqBlock>
    </main>
    <Footer></Footer>
    </template>
    <router-view v-else />
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import FirstBlock from "@/components/Blog/FirstBlock.vue";
import BlogList from "@/components/Templates/BlogList.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import PosotionImgContent from "@/components/Templates/PosotionImgContentRight.vue";
import SortBy from "@/components/UI/SortBy.vue";
import Search from "@/components/UI/Search.vue";
import axios from "axios";
import { registerAnimations } from '@/assets/directives/animations';
export default {
    components: {
        Header,
        Footer,
        FirstBlock,
        BlogList,
        FaqBlock,
        PosotionImgContent,
        Search,
        SortBy
    },
    data() {
        return {
            posts: [],
            filters: {
                search: '',
                sortBy: 1,
            },
            seacrhData: [],
            sortOptions: [
            {id: 1,title:'Latest'}, 
            {id: 2,title:'Oldest'}, 
            ],
        }
    },
    methods: {
        getSearchBlogs(e){
            let fData = new FormData();
            fData.append("name",e);
            axios.post("/get/blogs-search",fData).then(resp => {
            if (resp.data['result'] == true) {
                this.seacrhData = resp.data.blogs;
            }
            }).catch(()=>{}).finally(()=>{});
        },
        getBlogs(){
            let fData = new FormData();
            fData.append("filters",JSON.stringify(this.filters));
            axios.post("/get/blogs",fData).then(resp => {
                if (resp.data['result'] == true) {
                this.posts = resp.data.data;
                }
            }).catch(()=>{}).finally(()=>{
            });
        },
        fetchData() {
            axios.get('/api/data', { params: { url: this.$route.path } })
            .then(response => {
                this.$nextTick(() => {
                    registerAnimations(); // Инициализация анимаций после загрузки данных
                });
            });
        },
    },
    mounted () {
        this.getSearchBlogs('');
        this.getBlogs();
    },
    computed: {
        isProductPage() {
        return !!this.$route.params.slug;
        },
        fields() {
            return this.$store.state.fields;
        },
    },
    created() {
        this.fetchData(); // Загружаем данные при создании компонента
    },
    watch: {
    '$route': 'fetchData',
    'filters.search': function(newValue, oldValue) {
      this.getBlogs(); // Функция будет вызвана при изменении поиска
    },
    'filters.sortBy': function(newValue, oldValue) {
      this.getBlogs(); // Функция будет вызвана при изменении сортировки
    },
  },
}
</script>

<style scoped>
@media (max-width: 1024px) {
.sort-by{
    position: unset !important;
}
}
</style>